import React, { useEffect, useState, useCallback } from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import callApi from '../../utils/callApi';
import { ANNOUNCEMENTS } from '../../constants/apiUrls/apiUrls';


function Announcements() {
  const [data, setData] = useState([]);

  const getAnnouncements = () => {
    callApi(ANNOUNCEMENTS, 'get').then((res) => {
      if (typeof res.data === 'object') {
        setData(res.data);
      } else {
        setData([]);
      }
    }).catch(() => {
      setData([]);
    });
  };

  const renderAnnouncement = useCallback((announcement) => (
    <SplideSlide key={announcement?.url}>
      <a href={announcement?.url} >
        <img alt="announcement" className="announcement-image-desktop" src={announcement?.desktopImage} />
        <img alt="announcement" className="announcement-image-mobile" src={announcement?.mobileImage} />
      </a>
    </SplideSlide>
  ), []);


  useEffect(() => {
    getAnnouncements();
  }, []);

  if (!data.length) {
    return null;
  }

  return (
    <Splide
      autoPlay={false}
      type="loop"
      className="announcements-section"
      infiniteLoop={true}
      interval={8000}
      showIndicators={false}
      showStatus={false}
      showThumbs={false}
      swipeable={true}
    >
      {data?.map(renderAnnouncement)}
    </Splide>
  );
}

export default React.memo(Announcements);
